import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_moneris_event.js";
//#region src/bite_log_moneris_event_helper.ts
var bite_log_moneris_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 0: return "ok";
		case 1: return "terminal-connected";
		case 2: return "terminal-disconnected";
		case 3: return "sale-transaction-requested";
		case 4: return "sale-transaction";
		case 5: return "sale-transaction-error";
		case 6: return "device-setup";
		case 7: return "device-setup-error";
		case 8: return "refund-transaction-requested";
		case 9: return "refund-transaction";
		case 10: return "refund-transaction-error";
		case 11: return "logs";
		case 12: return "terminal-unresponsive-error";
		case 13: return "terminal-reboot-requested";
		case 14: return "terminal-reboot-skipped";
	}
}
//#endregion
export { bite_log_moneris_event_helper_exports, name };

//# sourceMappingURL=bite_log_moneris_event_helper.js.map